/* tslint:disable */

import { ConcreteRequest } from "relay-runtime";
export type tradePromoRule_QueryVariables = {
    userId: string;
};
export type tradePromoRule_QueryResponse = {
    readonly viewer: {
        readonly user: {
            readonly tradeFirm: {
                readonly rewards: {
                    readonly currentPromoSegment: {
                        readonly segmentCode: string | null;
                        readonly promotion: {
                            readonly code: string | null;
                        } | null;
                    } | null;
                } | null;
            } | null;
        } | null;
    } | null;
};
export type tradePromoRule_Query = {
    readonly response: tradePromoRule_QueryResponse;
    readonly variables: tradePromoRule_QueryVariables;
};



const node: ConcreteRequest = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "userId",
    "type": "String!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "userId",
    "variableName": "userId"
  }
],
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "segmentCode",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "code",
  "args": null,
  "storageKey": null
},
v4 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "tradePromoRule_Query",
    "type": "RootQueryType",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "user",
            "storageKey": null,
            "args": (v1/*: any*/),
            "concreteType": "User",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "tradeFirm",
                "storageKey": null,
                "args": null,
                "concreteType": "TradeFirmType",
                "plural": false,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "rewards",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "TradeFirmRewards",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "currentPromoSegment",
                        "storageKey": null,
                        "args": (v1/*: any*/),
                        "concreteType": "currentPromoSegmentType",
                        "plural": false,
                        "selections": [
                          (v2/*: any*/),
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "promotion",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "Promotion",
                            "plural": false,
                            "selections": [
                              (v3/*: any*/)
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "tradePromoRule_Query",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "user",
            "storageKey": null,
            "args": (v1/*: any*/),
            "concreteType": "User",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "tradeFirm",
                "storageKey": null,
                "args": null,
                "concreteType": "TradeFirmType",
                "plural": false,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "rewards",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "TradeFirmRewards",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "currentPromoSegment",
                        "storageKey": null,
                        "args": (v1/*: any*/),
                        "concreteType": "currentPromoSegmentType",
                        "plural": false,
                        "selections": [
                          (v2/*: any*/),
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "promotion",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "Promotion",
                            "plural": false,
                            "selections": [
                              (v3/*: any*/),
                              (v4/*: any*/)
                            ]
                          }
                        ]
                      }
                    ]
                  },
                  (v4/*: any*/)
                ]
              },
              (v4/*: any*/)
            ]
          },
          (v4/*: any*/)
        ]
      }
    ]
  },
  "params": {
    "operationKind": "query",
    "name": "tradePromoRule_Query",
    "id": "ferrum/246.0.0-2020-01-07T17:04:52.253Z/tradePromoRule_Query",
    "text": null,
    "metadata": {}
  }
};
})();
(node as any).hash = 'd85cb971657e2814969d3e76333bbf8d';
export default node;
